import React, { useEffect, useState } from 'react';
import {
  Button,
  Drawer,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { Pagination } from '../../../../components';
import { useNavigate } from 'react-router-dom';
import useDebounce from '../../../../components/Debounce';
import { Status } from '../../../../components/index';
import { useHook as equipmentInfo } from '../useHook';
import { useSelector } from 'react-redux';
import equipmentIcon from '../../../../assets/images/equiment_icon.svg';
import { useLocation } from 'react-router-dom';
import { ReactComponent as SearchIcon } from '../../../../assets/images/Search.svg';
import ActionButtons from '../../../../components/actionbutton';
import Filter from '../../../../assets/images/Filter.svg';
import EquimentFilter from '../equimentFilter';
import online from '../../../../assets/images/online.png';
import offline from '../../../../assets/images/offline.png';
import { closeBlackIcon } from '../../../../assets/images';

const SharedWithMe = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState<string>('');
  const debouncedSearch = useDebounce(search, 1000);
  const [totalPages, setTotalPages] = useState(1);
  const { equipmentInfoList, primaryField } = useSelector(
    (state: any) => state.equipmetInfo,
  );
  const { equipmentFilterList } = useSelector(
    (state: any) => state.equipmetInfo,
  );
  const {
    fetchGetEquipmentInfo,
    fetchReadPrimaryParameter,
    fetchGetEquipmentFilter,
  } = equipmentInfo();
  const [fliterDrawerOpen, setFliterDrawerOpen] = useState(false);
  const [filterEquipment, setFilterEquipment] = useState<string[]>([]);
  const [dealerCategory, setDealerCategory] = React.useState<string[]>([]);
  const [dealerSubcategory, setDealerSubcategory] = React.useState<string[]>(
    [],
  );
  const [filterDrawerData, setFilterDrawerData] = useState<any>(null);
  const [seeMoreIndex, setSeeMoreIndex] = useState<number>(2);
  const [storeUnitIds, setStoreUnitIds] = useState<any>([]);

  // useEffect(() => {
  //   if (equipmentInfoList?.sharedEquipments?.length > 0) {
  //     const unitIds = equipmentInfoList?.sharedEquipments?.map(
  //       (data: { unitID: any }) => {
  //         return data?.unitID;
  //       },
  //     );
  //     if (unitIds?.length > 0) {
  //       setStoreUnitIds(unitIds);
  //       getReadPrimaryParameter(unitIds);
  //     }
  //   }
  // }, [equipmentInfoList]);

  //gerreadprimary parameter

  const getReadPrimaryParameter = async (data: any[]) => {
    await fetchReadPrimaryParameter({ unitID: data });
  };

  useEffect(() => {
    if (!equipmentFilterList) {
      fetchGetEquipmentFilter();
    }
  }, []);

  useEffect(() => {
    if (debouncedSearch) {
      getData(1, rowsPerPage, search);
      setCurrentPage(1);
    }
  }, [debouncedSearch]);

  const handleRemoveFilter = (filterName: string) => {
    if (dealerSubcategory.includes(filterName)) {
      const removeData = dealerSubcategory?.filter(
        (data) => data !== filterName,
      );
      setDealerSubcategory(removeData);

      const removeFilterData = filterEquipment?.filter(
        (data) => data !== filterName,
      );
      setFilterEquipment(removeFilterData);
    } else if (dealerCategory.includes(filterName)) {
      const removeData = dealerCategory?.filter((data) => data !== filterName);
      setDealerCategory(removeData);

      // Find the subcategories to remove based on the category name
      const removedSubcategories =
        equipmentFilterList?.category?.find(
          (category: { categoryName: string }) =>
            category.categoryName === filterName,
        )?.subCategories || [];

      // Remove subcategories from subcategoryFilter
      const removeSubCategoryData = dealerSubcategory.filter(
        (item) => !removedSubcategories.includes(item),
      );
      setDealerSubcategory(removeSubCategoryData);
      // Remove from filterData (both category and subcategory)
      const removeFilterData = filterEquipment.filter(
        (item) => !removedSubcategories.includes(item) && item !== filterName,
      );
      setFilterEquipment(removeFilterData);
    }
    // const removeData = filterEquipment?.filter((data) => data !== filterName);
    // setFilterEquipment(removeData);
    setCurrentPage(1);
  };

  // useEffect(() => {
  //   if (pathname === '/equipment/sharedwithmeequipment') {
  //     getData();
  //   }
  // }, [pathname]);
  useEffect(() => {
    const pathname = location.pathname;
    if (pathname === '/equipment/sharedwithmeequipment') {
      getData(currentPage, rowsPerPage, search);
      setSeeMoreIndex(filterEquipment?.length);
      setFilterDrawerData({
        category: dealerCategory.length > 0 ? dealerCategory : [],
        subCategory: dealerSubcategory.length > 0 ? dealerSubcategory : [],
      });
    }
  }, [filterEquipment]);

  const getData = async (
    pagenumber?: number,
    row_perpage?: number,
    search: unknown = '',
    sort: { orderBy: string; order: number } = {
      orderBy: 'updatedAt',
      order: -1,
    },
    filters?: any,
  ) => {
    const payload = {
      sort: sort,
      search: search,
      limit: row_perpage ? row_perpage : rowsPerPage,
      offset: pagenumber
        ? (pagenumber - 1) * rowsPerPage
        : (currentPage - 1) * rowsPerPage,
      filters: {
        category: dealerCategory?.length > 0 ? dealerCategory : null,
        subCategory: dealerSubcategory?.length > 0 ? dealerSubcategory : null,
      },
    };

    await fetchGetEquipmentInfo(payload).then((res: any) => {
      const totalPage = res?.sharedEquipmentCount
        ? Math.ceil(
            res?.sharedEquipmentCount /
              (row_perpage ? row_perpage : rowsPerPage),
          )
        : 1;
      setTotalPages(totalPage);

      if (res?.sharedEquipments?.length > 0) {
        const unitIds = res?.sharedEquipments?.map((data: { unitID: any }) => {
          return data?.unitID;
        });
        if (unitIds?.length > 0) {
          setStoreUnitIds(unitIds);
          getReadPrimaryParameter(unitIds);
        }
      }
    });
  };

  //pagination
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    getData(page, rowsPerPage, search);
  };
  const handleRowsPerPageChange = (value: number) => {
    getData(1, value, search);
    setRowsPerPage(value);
    setCurrentPage(1);
  };

  const handleSearchChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const search = event.target.value;
    // Allow only letters, numbers, and spaces
    const regex = /^[a-zA-Z0-9 ]*$/;
    if (regex.test(search)) {
      setSearch(search);

      if (!search) {
        getData(currentPage, rowsPerPage, search);
      } else {
        setCurrentPage(1);
      }
    }
  };

  const fliterOpenDrawer = () => {
    setFliterDrawerOpen(true);
  };
  const fliterCloseDrawer = () => {
    setFliterDrawerOpen(false);
  };

  const handleFilterEquipment = (data: any) => {
    setFilterEquipment([...data.category, ...data.subcategory]);
    setDealerCategory(data.category);
    setDealerSubcategory(data.subcategory);
    setFliterDrawerOpen(false);
    setCurrentPage(1);
  };

  //getprimaryvalue
  const getPrimaryValue = (unitId: any) => {
    const primaryData = primaryField?.find(
      (data: { unitID: any }) => data.unitID === unitId,
    );
    return primaryData?.coiltemp
      ? primaryData?.coiltemp?.toFixed(2) + '  °C'
      : '-';
  };
  return (
    <>
      <>
        <div className="ownEquipment_header">
          <div className="ownEquipment_header-search">
            <div>
              <ActionButtons
                image={Filter}
                title={'Filter'}
                action={fliterOpenDrawer}
                activeData={filterEquipment}
              />
            </div>
            <div className="table-header-btn">
              <TextField
                variant="outlined"
                placeholder="Search"
                value={search}
                onChange={handleSearchChange}
                InputProps={{
                  startAdornment: <SearchIcon />,
                }}
                className="search-input"
              />
            </div>
          </div>
          <div>
            {filterEquipment?.slice(0, seeMoreIndex).map((data, index) => (
              <div key={index} className="filterlist">
                <p>{data}</p>
                <Button onClick={() => handleRemoveFilter(data)}>
                  <img src={closeBlackIcon} alt="Delete Icon" width={13} />
                </Button>
              </div>
            ))}
            {filterEquipment?.length > 2 && seeMoreIndex === 2 && (
              <div className="see_more_data">
                <Button
                  onClick={() => setSeeMoreIndex(filterEquipment?.length)}
                >{`+${filterEquipment?.length - 2} More`}</Button>
              </div>
            )}
            {filterEquipment?.length > 2 && seeMoreIndex !== 2 && (
              <div className="see_more_data">
                <Button onClick={() => setSeeMoreIndex(2)}>show less</Button>
              </div>
            )}
          </div>
          <TableContainer className="controller_table" component={Paper}>
            <Table>
              <TableHead className="controller_tableheader">
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Model</TableCell>
                  {/* <TableCell>Temperature</TableCell> */}
                  <TableCell>Temperature</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Subcategory</TableCell>
                  <TableCell>Subscription Status</TableCell>
                  <TableCell>Device Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {!equipmentInfoList?.sharedEquipments ||
                equipmentInfoList?.sharedEquipments?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={2}>
                      <Typography variant="body1" align="left">
                        No Data found
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  equipmentInfoList?.sharedEquipments?.map(
                    (equipment: any, index: number) => (
                      <TableRow key={index}>
                        <TableCell>
                          <div className="equipment_online-btn">
                            <Button
                              className="controller_management_name-data equipment_navigate-btn "
                              onClick={() =>
                                navigate(
                                  `/equipment/sharedwithmeequipment/details/${equipment?.equipmentName.replace(/ /g, '_') || ' '}/${equipment?.unitID}`,
                                )
                              }
                            >
                              <img
                                src={
                                  equipment?.equipmentImage
                                    ? equipment?.equipmentImage
                                    : equipmentIcon
                                }
                                width={40}
                                alt="User Profile"
                              />{' '}
                              {equipment?.status == 'active' ? (
                                <img
                                  className="equipment_online-img"
                                  src={online}
                                  alt="net work"
                                />
                              ) : (
                                <img
                                  className="equipment_online-img"
                                  src={offline}
                                  alt="net work"
                                />
                              )}
                              <p>
                                {equipment?.equipmentName || equipment?.unitID}
                              </p>
                            </Button>
                            {/* {equipment?.status == 'active' ? (
                              <Status status={'online'} />
                            ) : (
                              <Status status={'offline'} />
                            )} */}
                          </div>
                        </TableCell>
                        <TableCell>
                          <p className="controller_management_model-data">
                            {equipment?.equipmentModel}
                          </p>
                        </TableCell>
                        {/* <TableCell>
                          <div className="controller_management_model-data">
                            <p>
                              {equipment?.tempValue
                                ? `${equipment.tempValue}°C`
                                : '-'}
                            </p>
                          </div>
                        </TableCell> */}

                        <TableCell>
                          <div className="controller_management_model-data">
                            <p>{getPrimaryValue(equipment?.unitID)}</p>
                          </div>
                        </TableCell>

                        <TableCell>
                          <div className="controller_management_model-data">
                            <p>{equipment?.category}</p>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className="controller_management_model-data">
                            <p>{equipment?.subCategory}</p>
                          </div>
                        </TableCell>
                        {/* <TableCell>
                          <div className="controller_management_model-data">
                            <p>{equipment?.temperature || '-'}</p>
                          </div>
                        </TableCell> */}
                        <TableCell>
                          {equipment?.subscriptionStatus ? (
                            <Status status={equipment?.subscriptionStatus} />
                          ) : (
                            '-'
                          )}

                          {/* <div className="form-action-btn">
                      <Button
                        className="btn-transparent border-0 img-background-form"
                        onClick={() =>
                          navigate(
                            `/hardware/equipments/edit/${equipment?.equipmentName ? equipment?.equipmentName : ' '}/${equipment.equipmentID}`,
                          )
                        }
                      >
                        <i className="edit-icon bi bi-pencil-square bi-lg"></i>
                      </Button>
                    </div> */}
                        </TableCell>
                        <TableCell>
                          {equipment?.deviceState ? (
                            <div
                              className={`user_management_status-data ${equipment?.deviceState?.toLocaleLowerCase() || 'inactive'}`}
                            >
                              {equipment?.deviceState?.toLocaleLowerCase() ===
                              'on'
                                ? 'On'
                                : 'Off'}
                            </div>
                          ) : (
                            <div className="user_management_status-data inactive">
                              Off
                            </div>
                          )}
                        </TableCell>
                      </TableRow>
                    ),
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Pagination
            rowsPerPageOptions={[5, 10, 20, 30]}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            totalPages={totalPages}
          />
          <Drawer
            open={fliterDrawerOpen}
            anchor="right"
            onClose={fliterCloseDrawer}
          >
            <EquimentFilter
              fliterCloseDrawer={fliterCloseDrawer}
              filterSubmit={handleFilterEquipment}
              filterDrawerData={filterDrawerData}
            />
          </Drawer>
        </div>
      </>
    </>
  );
};

export default SharedWithMe;
